import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-12 md:py-24 px-4 bg-cream-200 relative" data-id="element-66">
      <div className="max-w-5xl mx-auto" data-id="element-67">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-68">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1 relative" data-id="element-69">
            <div className="absolute -inset-4 border border-amber-500/30 rounded-sm transform -rotate-2" data-id="element-70"></div>
            <div className="absolute -inset-4 border border-forest-800/20 rounded-sm transform rotate-1" data-id="element-71"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hhVFpkjMAY9RWgcDfA3dNS/mk-2.png" alt="Protocolo de Extracción Express en Tablet" className="relative z-10 w-full h-auto rounded-sm shadow-2xl" data-id="element-72" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 space-y-5 md:space-y-8" data-id="element-73">
            <div data-id="element-74">
              <span className="text-amber-600 font-bold tracking-wider uppercase text-sm mb-2 block font-lora" data-id="element-75">
                El Secreto
              </span>
              <h2 className="text-3xl md:text-4xl font-playfair font-bold text-forest-900 leading-tight" data-id="element-76">
                El Protocolo de Extracción Express
              </h2>
            </div>

            <div className="w-16 h-1 bg-amber-500 rounded-full" data-id="element-77"></div>

            <div className="space-y-6 font-lora text-lg text-ink-800 leading-relaxed" data-id="element-78">
              <p data-id="element-79">
                Este no es un libro de recetas de abuela. Es una guía de{' '}
                <strong className="text-forest-800 font-semibold" data-id="element-80">
                  "química doméstica"
                </strong>{' '}
                que te enseña a identificar el solvente, la temperatura y el
                tiempo exacto para extraer el compuesto bioactivo de 7
                ingredientes clave.
              </p>
              <p className="p-6 bg-cream-100 border border-amber-500/20 rounded-sm shadow-sm" data-id="element-81">
                Aprenderás a{' '}
                <span className="text-amber-600 font-bold italic" data-id="element-82">
                  "encender"
                </span>{' '}
                la medicina que ya compraste en el mercado.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}